import { render } from "./Article-editor-tab.vue?vue&type=template&id=94fc39d6&scoped=true"
import script from "./Article-editor-tab.vue?vue&type=script&lang=js"
export * from "./Article-editor-tab.vue?vue&type=script&lang=js"

import "./Article-editor-tab.vue?vue&type=style&index=0&id=94fc39d6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94fc39d6"]])

export default __exports__